import { actionStore } from '../components/ShortcutManager/Store';

import useSimpleStore from './useSimpleStore';

const useShortcutManager = () => {
  return useSimpleStore(actionStore)[0];
};

export default useShortcutManager;
